import React, {Suspense} from "react";
import {createRoot} from "react-dom/client";
import GiftBlock from "./GiftBlock";

/**
 * GiftBlock component is required annually for the Christmas season and should be reintegrated in november
 */

class GiftBlockPortal {
  public static run(element: HTMLDivElement): void {
    const root = createRoot(element);
    root.render(
      <Suspense fallback={null}>
        <GiftBlockContent elem={element} />
      </Suspense>,
    );
  }
}

const GiftBlockContent: React.FC<{elem: HTMLDivElement}> = ({elem}) => {
  const {giftImage, giftTitle} = elem.dataset;

  if (giftImage && giftTitle) {
    return <GiftBlock productImage={giftImage} productTitle={giftTitle} />;
  } else {
    return null;
  }
};
export default GiftBlockPortal;
